module.exports = __webpack_public_path__ + "static/dic-fbb40323e8034f232cbf85f61229bfba.png";